import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Acknowledgement from '../leasing/Acknowledgement';
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
import ContractClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractClause';
import ContractAddendumClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClause';
import IOwner from '../IOwner';
import IContract from './IContract';
import Owner from '../tract_detail/Owner';
import WIContractOwnership from '../tract_detail/WIContractOwnership';
import ProvisionLeaseClause from '../ProvisionLeaseClause';

export default class CarbonCapture implements IContract {
    id?: number;
    name: string;
    leaseNumber: number;
    leaseDate: Date;
    recordTypeId?: number;
    poolingOrderNo: string;
    lessorAka: string;
    isActive?: boolean;
    modifiedByUserId?: number;
    originalGrossAcres?: number;
    primaryTerm?: number;
    primaryTermTypeId?: number;
    optionExercised?: boolean;
    optionAmount?: number;
    optionAmountTypeId?: number;
    optionTerm?: number;
    optionTermTypeId?: number;
    secondOptionExercised?: boolean;
    secondOptionAmount?: number;
    secondOptionAmountTypeId?: number;
    secondOptionTerm?: number;
    secondOptionTermTypeId?: number;
    isRental?: boolean;
    rentalPrice?: number;
    rentalPriceTypeId?: number;
    coalPrice?: number;
    coalPriceTypeId?: number;

    // Global props
    clientDocNumber: string;
    leasedBy: string;
    effectiveDate: Date;
    reminderDate?: Date;
    reminderNote: string;
    isCommitted?: boolean;
    commitDate?: Date;
    isInHand?: boolean;
    inHandDate?: Date;
    isVoid?: boolean;
    voidDate?: Date;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId?: number;
    isNotOriginalLessee?: boolean;
    originalLessor: string;
    originalLessee: string;
    legalDescription: string;
    rteLegalDescription: string;
    shortLegalDescription: string;
    isGeneratedLease?: boolean;
    createdDate: Date;
    leaseLessorNotes: string;
    ownersAddressOnDocument: string;
    ownersOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    isFiledByMemo?: boolean;
    bonusAmount?: number;
    bonusTypeId?: number;
    volume: string;
    page: string;
    instrumentNumber: string;
    recordedDate: Date;
    originalInHandDate?: Date;

    // Not Mapped
    bonusType: string;
    optionAmountType: string;
    optionTermType: string;
    secondOptionAmountType: string;
    secondOptionTermType: string;
    primaryTermType: string;
    rentalPriceType: string;
    coalPriceType: string;
    invoiceableLookupId?: number;
    currentHold?: CarbonCaptureHold;
    carbonCaptureHolds?: Array<CarbonCaptureHold>;
    tracts?: Array<ContractGenerationTractDetail>;
    adHocClauses?: Array<ContractClause>;
    contractClauses?: Array<ContractAddendumClause>;
    acknowledgements?: Array<Acknowledgement>;
    contractAmendments?: Array<ContractAmendment>;
}

export class CarbonCaptureHold {
    id?: number;
    carbonCaptureId?: number;
    holdNumber?: number;
    projectId?: number;
    operator: string;
    apiNo: string;
    unitName: string;
    fieldName: string;
    fedStateLeaseNo: string;
    seismicDataReq?: boolean;
    
    royalty?: number;
    notes?: string;
    isActive?: boolean;
    isHistorical?: boolean;
    hbp?: boolean;
    hbu?: boolean;
    
    // Not Mapped
    contractLookupId?: number;
    surfaceOwner: IOwner;
    ownershipId?: number;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    provisionLeaseClauses?: Array<ProvisionLeaseClause>;
}


// WEBPACK FOOTER //
// ./src/models/contract_types/CarbonCapture.ts